import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { amplitudeError } from './components/amplitude';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Aqui você pode logar o erro para um serviço de monitoramento, por exemplo
        console.error('Erro capturado:', error, errorInfo);

        if (error?.message) {
            amplitudeError(error, error.message, error.stack || errorInfo.componentStack);
        }

    }

    render() {
        if (this.state.hasError) {
            // Você pode redirecionar para uma tela de erro
            return <Redirect to="/errors/error" />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;